module.exports = __webpack_public_path__ + "img/calendar.de6bd1e2.png";